module.exports = __webpack_public_path__ + "static/media/transaction_history.9bb92c3b.svg";